import React, { useState, useEffect } from "react";
import { Input } from "@material-tailwind/react";
import { getCurrency } from "../../services/sales";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CustomInput from "../CustomInput";

const SaleAgreementDetails = ({
  formData,
  handleInputChange,
  onTotalAmountChange,
  onPaymentOptionSelect,
  property,
  paymentInstallments = [],
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isBankLoanInvolved, setIsBankLoanInvolved] = useState(formData.isBankLoanInvolved || false);
  console.log("this the form data for %", formData)
  const [paymentOption, setPaymentOption] = useState(
    formData.paymentOption || ""
  );
  const [currencies, setCurrencies] = useState([]);
  const [isCurrencyDropdownOpen, setIsCurrencyDropdownOpen] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(
    formData.currencyId ? formData.currencyId : null
  );

  const [stampDuty, setStampDuty] = useState(formData.stampDuty || 0);
  const [gst, setGst] = useState(formData.gst || 0);
  const [registrationPrice, setRegistrationPrice] = useState(
    formData.registrationPrice || 0
  );

  console.log("this is the property", property)
  const configuration = property?.projectPhase?.project?.configuration || {}; 
  const stampDutyPercents = configuration.stampDutyPercent || [];
  const gstPercents = configuration.gstPercent || [];
  const registrationPercents = configuration.registrationPercent || [];

  const [selectedStampDutyPercent, setSelectedStampDutyPercent] = useState("");
  const [selectedGstPercent, setSelectedGstPercent] = useState("");
  const [selectedRegistrationPercent, setSelectedRegistrationPercent] = useState("");

  // Fetch currencies
  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const response = await getCurrency();
        setCurrencies(response);
      } catch (error) {
        console.error("Error fetching currencies:", error);
        alert("Error fetching currencies: " + error.message);
      }
    };

    fetchCurrencies();
  }, []);

  // Function to calculate percentage-based values
  const calculatePercentageValue = (baseValue, percentage) => {
    const base = parseFloat(baseValue) || 0;
    const percent = parseFloat(percentage) || 0;
    return (base * percent) / 100;
  };

  // Calculate the total amount
  const calculateTotalAmount = () => {
    const basePrice = parseFloat(formData.basePrice) || 0;
    return basePrice;
  };

  const [totalAmount, setTotalAmount] = useState(calculateTotalAmount());

  useEffect(() => {
    const calculatedAmount = calculateTotalAmount();
    setTotalAmount(calculatedAmount);
    onTotalAmountChange(calculatedAmount);
  }, [stampDuty, gst, registrationPrice, formData.basePrice]);

  // Update stampDuty, gst, registrationPrice when basePrice or percentages change
  useEffect(() => {
    const basePrice = parseFloat(formData.basePrice) || 0;

    if (selectedStampDutyPercent !== "") {
      const newStampDuty = calculatePercentageValue(basePrice, selectedStampDutyPercent)
      setStampDuty(newStampDuty);
      handleInputChange({ target: { name: "stampDuty", value: newStampDuty } });
    }
    if (selectedGstPercent !== "") {
      const newGST = calculatePercentageValue(basePrice, selectedGstPercent)
      setGst(newGST);
      handleInputChange({ target: { name: "gst", value: newGST } });
    }
    if (selectedRegistrationPercent !== "") {
      const newRegistrationPrice = calculatePercentageValue(basePrice, selectedRegistrationPercent)
      setRegistrationPrice(newRegistrationPrice);
      handleInputChange({ target: { name: "registrationPrice", value: newRegistrationPrice } });
    }
  }, [formData.basePrice, selectedStampDutyPercent, selectedGstPercent, selectedRegistrationPercent]);


  const handleDropdownToggle = () => setIsDropdownOpen(!isDropdownOpen);

  const handlePaymentOptionSelect = (option) => {
    setPaymentOption(option);
    handleInputChange({
      target: { name: "paymentOption", value: option },
    });
    onPaymentOptionSelect(option);
    setIsDropdownOpen(false);
  };

  const handleCurrencyDropdownToggle = () =>
    setIsCurrencyDropdownOpen(!isCurrencyDropdownOpen);

  const handleCurrencySelect = (currency) => {
    handleInputChange({
      target: { name: "currencyId", value: currency.currencyId },
    });
    setSelectedCurrency(currency.currencyId);
    setIsCurrencyDropdownOpen(false);
  };

  const handleStampDutyChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    setStampDuty(value);
    handleInputChange({ target: { name: "stampDuty", value: value } });
  };

  const handleGstChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    setGst(value);
    handleInputChange({ target: { name: "gst", value: value } });
  };

  const handleRegistrationPriceChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    setRegistrationPrice(value);
    handleInputChange({ target: { name: "registrationPrice", value: value } });
  };

  const handleDateChange = (dateString) => {
    handleInputChange({
      target: {
        name: "saleDate",
        value: dateString,
      },
    });
  };

  const handleBankLoanToggle = (e) => {
    const value = e.target.checked;
    setIsBankLoanInvolved(value);
    handleInputChange({
      target: { name: "isBankLoanInvolved", value: value },
    });
  };

  // Helper functions for formatting
  const formatDate = (date) => {
    if (!date) return "N/A";
    try {
      const dateObj = new Date(date);
      return dateObj.toLocaleDateString();
    } catch (e) {
      return "N/A";
    }
  };

  const formatNumber = (number) => {
    return parseFloat(number || 0).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const getPaymentTypeName = (paymentTypeId) => {
    const paymentTypes = {
      1: "Token Payment",
      2: "Scheduled Payment",
      3: "Full Payment",
      4: "Down Payment",
      5: "Slab Wise Payment",
      6: "Hybrid Payment"
    };
    return paymentTypes[paymentTypeId] || "Unknown";
  };

  // Debug logging for payment installments
  useEffect(() => {
    console.log("SaleAgreementDetails - paymentInstallments changed:", paymentInstallments);
  }, [paymentInstallments]);

  return (
    <>
      <div >
        <div className="flex items-center mb-4">
          <h2 className="font-semibold text-slate-800">
            Sale and Agreement Details
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 bg-white pb-20 max-h-[100vh]" >
          {/* Sale Date */}
          <CustomInput
            label="Sale Date"
            type="date"
            value={formData.saleDate || ""} 
            onChange={(e) => handleDateChange(e.target.value)}
            required
          />

          {/* Base Price */}
          <div>
            <label
              htmlFor="basePrice"
              className="block text-sm font-normal text-gray-700 mt-2"
            >
              Agreement Value <span className="text-red-500">*</span>
            </label>
            <Input.Field
              type="number"
              id="basePrice"
              name="basePrice"
              value={formData.basePrice || 0}
              onChange={handleInputChange}
              className="h-10 rounded-lg"
              required
            />
          </div>

          {/* Currency ID */}
          <div>
            <label
              htmlFor="currencyId"
              className="block text-sm font-normal text-gray-700 mb-1"
            >
              Currency <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <div
                className="cursor-pointer h-10 flex items-center justify-between border rounded-lg px-4"
                onClick={handleCurrencyDropdownToggle}
              >
                <span className="font-normal text-sm">
                  {selectedCurrency
                    ? currencies.find(
                      (currency) => currency.currencyId === selectedCurrency
                    )?.currencyName
                    : "Select Currency"}
                </span>
                <span className="text-sm text-gray-500">▼</span>
              </div>
              {isCurrencyDropdownOpen && (
                <div className="absolute w-full mt-1 bg-white border rounded-lg shadow-md z-10">
                  {currencies.map((currency) => (
                    <div
                      key={currency.currencyId}
                      className="px-4 py-2 font-normal text-sm cursor-pointer hover:bg-gray-200"
                      onClick={() => handleCurrencySelect(currency)}
                    >
                      {currency.currencyName}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Stamp Duty */}
          <div>
            <label className="block text-sm font-normal text-gray-700 mb-1">Stamp Duty</label>
            <div className="flex items-center gap-2">
              <select
                className="w-1/3 p-2 my-2 border-2 border-gray-100 rounded-lg bg-white text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-300 focus:outline-none h-10"
                value={selectedStampDutyPercent}
                onChange={(e) => setSelectedStampDutyPercent(e.target.value)}
                id="stampDutyPercent"
              >
                <option value="" disabled={selectedStampDutyPercent !== ""}>Select %</option>
                {stampDutyPercents.map((percent) => (
                  <option key={percent} value={percent}>
                    {percent}%
                  </option>
                ))}
              </select>
              <Input.Field
                type="number"
                id="stampDuty"
                name="stampDuty"
                value={stampDuty}
                onChange={handleStampDutyChange}
                className="w-2/3 h-10 rounded-lg"
              />
            </div>
          </div>

          {/* GST */}
          <div>
            <label className="block text-sm font-normal text-gray-700 mb-1">
              GST
            </label>
            <div className="flex items-center gap-2">
              <select
                className="w-1/3 p-2 my-2 border-2 border-gray-100 rounded-lg bg-white text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-300 focus:outline-none h-10"
                value={selectedGstPercent}
                onChange={(e) => setSelectedGstPercent(e.target.value)}
                id="gstPercent"
              >
                <option value="" disabled={selectedGstPercent !== ""}>Select %</option>
                {gstPercents.map((percent) => (
                  <option key={percent} value={percent}>
                    {percent}%
                  </option>
                ))}
              </select>
              <Input.Field
                type="number"
                id="gst"
                name="gst"
                value={gst}
                onChange={handleGstChange}
                className="w-2/3 h-10 rounded-lg"
              />
            </div>
          </div>

          {/* Registration Price */}
          <div>
            <label className="block text-sm font-normal text-gray-700 mb-1">
              Registration
            </label>
            <div className="flex items-center gap-2">
              <select
                className="w-1/3 p-2 my-2 border-2 border-gray-100 rounded-lg bg-white text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-300 focus:outline-none h-10"
                value={selectedRegistrationPercent}
                onChange={(e) => setSelectedRegistrationPercent(e.target.value)}
                id="registrationPercent"
              >
                <option value="" disabled={selectedRegistrationPercent !== ""}>Select %</option>
                {registrationPercents.map((percent) => (
                  <option key={percent} value={percent}>
                    {percent}%
                  </option>
                ))}
              </select>
              <Input.Field
                type="number"
                id="registrationPrice"
                name="registrationPrice"
                value={registrationPrice}
                onChange={handleRegistrationPriceChange}
                className="w-2/3 h-10 rounded-lg"
              />
            </div>
          </div>

          {/* Payment Option Dropdown and Bank Loan Checkbox */}
          <div className="flex items-center gap-4">
            <div className="w-full">
              <label
                htmlFor="paymentOption"
                className="block text-sm font-normal text-gray-700 mb-1"
              >
                Payment Option <span className="text-red-500">*</span>
              </label>
              <div className="relative overflow-visible">
                <div
                  className="cursor-pointer h-10 flex items-center justify-between border rounded-lg px-4"
                  onClick={handleDropdownToggle}
                >
                  <span className="font-normal text-sm">
                    {paymentOption || "Select Payment Option"}
                  </span>
                  <span className="text-sm text-gray-500">▼</span>
                </div>
                {isDropdownOpen && (
                  <div className="absolute w-full mt-1 bg-white border rounded-lg shadow-md z-50">
                    <div
                      className="px-4 py-2 font-normal text-sm cursor-pointer hover:bg-gray-200"
                      onClick={() => handlePaymentOptionSelect("SLAB_WISE")}
                    >
                      SLAB_WISE
                    </div>
                    <div
                      className="px-4 py-2 cursor-pointer font-normal text-sm hover:bg-gray-200"
                      onClick={() => handlePaymentOptionSelect("SCHEDULED")}
                    >
                      SCHEDULED
                    </div>
                    <div
                      className="px-4 py-2 cursor-pointer font-normal text-sm hover:bg-gray-200"
                      onClick={() => handlePaymentOptionSelect("HYBRID")}
                    >
                      HYBRID
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="flex items-center h-full mt-6">
              <input
                type="checkbox"
                id="isBankLoanInvolved"
                checked={isBankLoanInvolved}
                onChange={handleBankLoanToggle}
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <label htmlFor="isBankLoanInvolved" className="ml-2 text-sm font-normal text-gray-700">
                Bank Loan Involved
              </label>
            </div>
          </div>

          {/* Bank Loan Section */}
          {isBankLoanInvolved && (
            <div className="col-span-3">
              <div className="grid grid-cols-4 gap-4 mb-4">
                {/* Bank Name */}
                <div>
                  <label
                    htmlFor="bankName"
                    className="block text-sm font-normal text-gray-700 mb-1"
                  >
                    Bank Name <span className="text-red-500">*</span>
                  </label>
                  <Input.Field
                    type="text"
                    id="bankName"
                    name="bankName"
                    value={formData.bankName || ""}
                    onChange={handleInputChange}
                    className="h-10 rounded-lg"
                    required={isBankLoanInvolved}
                    placeholder="Enter bank name"
                  />
                </div>

                {/* Branch */}
                <div>
                  <label
                    htmlFor="branch"
                    className="block text-sm font-normal text-gray-700 mb-1"
                  >
                    Branch <span className="text-red-500">*</span>
                  </label>
                  <Input.Field
                    type="text"
                    id="branch"
                    name="branch"
                    value={formData.branch || ""}
                    onChange={handleInputChange}
                    className="h-10 rounded-lg"
                    required={isBankLoanInvolved}
                    placeholder="Enter branch name"
                  />
                </div>

                {/* Loan Amount */}
                <div>
                  <label
                    htmlFor="loanAmount"
                    className="block text-sm font-normal text-gray-700 mb-1"
                  >
                    Loan Amount <span className="text-red-500">*</span>
                  </label>
                  <Input.Field
                    type="number"
                    id="loanAmount"
                    name="loanAmount"
                    value={formData.loanAmount || ""}
                    onChange={handleInputChange}
                    className="h-10 rounded-lg"
                    required={isBankLoanInvolved}
                    placeholder="Enter loan amount"
                  />
                </div>

                {/* Bank Email */}
                <div>
                  <label
                    htmlFor="bankEmail"
                    className="block text-sm font-normal text-gray-700 mb-1"
                  >
                    Bank Email ID <span className="text-red-500">*</span>
                  </label>
                  <Input.Field
                    type="email"
                    id="bankEmail"
                    name="bankEmail"
                    value={formData.bankEmail || ""}
                    onChange={handleInputChange}
                    className="h-10 rounded-lg"
                    required={isBankLoanInvolved}
                    placeholder="Enter bank email"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SaleAgreementDetails;